import { render, staticRenderFns } from "./VsPageViews.vue?vue&type=template&id=697edb28&scoped=true&"
import script from "./VsPageViews.vue?vue&type=script&lang=js&"
export * from "./VsPageViews.vue?vue&type=script&lang=js&"
import style0 from "./VsPageViews.vue?vue&type=style&index=0&id=697edb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697edb28",
  null
  
)

export default component.exports